import { FC } from 'react'
import { CenterScreenModal } from '../atoms'
import { useLogoutHandler, useOpeningElementsControllerContext, useUserLanguage } from '@/customHooks'
import { ConfirmationDialog } from '../organism';
import textsData from '@/textData/UserLogoutDialogTexts.json'

export const UserLogoutDialogModal: FC = () => {
  const { state, logoutConfirmationModalClose} = useOpeningElementsControllerContext();

  const logout = useLogoutHandler()

  const onLogoutHandle = () => {
    logoutConfirmationModalClose()
    logout()
  }

  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  return (
    <CenterScreenModal
      isOpen={state.isLogoutConfirmationModalOpen}
      onClose={logoutConfirmationModalClose}
    >
      <ConfirmationDialog
        title={texts.title}
        description={texts.description}
        confirmButton={{ action: onLogoutHandle, text: texts.buttons.confirm}}
        cancelButton={{ action: logoutConfirmationModalClose, text: texts.buttons.cancel}}
      />
    </CenterScreenModal>
  )
}